import React from 'react';

import { Title, useAdaptive } from '@skillarea/lib-frontend';
import { GameReturnDto } from '@skillarea/lib-shared';
import { Trans } from 'react-i18next';

import cx from 'classnames';

import { GamesSection } from '../GamesSection/GamesSection';
import { Leaderboard } from '../Leaderboard/Leaderboard';
import { Chests } from '../Chests/Chests';

import styles from './Dashboard.module.scss';

import { Container } from '~/components/Container/Container';

interface IDashboardProps {
  isLoading?: boolean;
  gamesData?: { items: Record<number, GameReturnDto> } | undefined;
}

export const Dashboard: React.FC<IDashboardProps> = ({
  gamesData,
  isLoading = false,
}) => {
  const { isMobile, isTablet } = useAdaptive();
  const size = isMobile ? 'xs' : isTablet ? 's' : 'm';

  return (
    <Container className={styles.dashboardContainer}>
      <Chests />
      <Title
        className={cx(styles.title)}
        color="contrast"
        size={size}
        variant="benzin"
      >
        <Trans
          components={{
            accent: (
              <Title
                color="accent"
                isInsertion
                size={size}
                variant="cormorant"
              />
            ),
          }}
          i18nKey="chooseGame"
          ns="dashboard"
        />
      </Title>
      <section className={styles.gamesSection}>
        <GamesSection
          gamesData={gamesData}
          gridClassName={styles.gamesGrid}
          isLoading={isLoading}
        />
      </section>
      <Leaderboard />
    </Container>
  );
};
